// Utility functions for date/time formatting

/**
 * Format UTC time from ISO string
 * @param isoString - ISO 8601 date string (e.g., "2026-06-03T10:41:10.507Z")
 * @returns Formatted UTC time (e.g., "10:41 AM")
 */
export const formatUTCTime = (isoString: string): string => {
  const date = new Date(isoString);
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  
  // Convert to 12-hour format
  const hour12 = hours % 12 || 12;
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const minutesStr = String(minutes).padStart(2, '0');
  
  return `${hour12}:${minutesStr} ${ampm}`;
};

export const formatLocalTime = (isoString: string): string => {
  const date = new Date(isoString);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  
  // Convert to 12-hour format
  const hour12 = hours % 12 || 12;
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const minutesStr = String(minutes).padStart(2, '0');
  
  return `${hour12}:${minutesStr} ${ampm}`;
};

/**
 * Format UTC date and time from ISO string
 * @param isoString - ISO 8601 date string
 * @param options - Formatting options
 * @returns Formatted UTC date and time
 */
export const formatUTCDateTime = (
  isoString: string,
  options: { includeDate?: boolean; includeYear?: boolean } = {}
): string => {
  const date = new Date(isoString);
  const { includeDate = true, includeYear = false } = options;
  
  if (!includeDate) {
    return formatUTCTime(isoString);
  }
  
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = months[date.getUTCMonth()];
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();
  const time = formatUTCTime(isoString);
  
  if (includeYear) {
    return `${month} ${day}, ${year}, ${time}`;
  }
  
  return `${month} ${day}, ${time}`;
};
